

import axios from 'axios'
import { fetchrootpath } from '../../components/api_servcies/apirootpath'
export const FETCH_DDMASTER_REQUEST = "FETCH_DDMASTER_REQUEST"
export const FETCH_DDMASTER_SUCCESS = "FETCH_DDMASTER_FAILURE"
export const FETCH_DDMASTER_FAILURE = "FETCH_POLY_CROP_FAILURE"
const URL = `${fetchrootpath}/fetch/searchvillage`
export const FetchDDmaster = (searchstr) => async dispatch => {
    dispatch({type: FETCH_DDMASTER_REQUEST})
    try{ ;
        const res = await axios.get(URL ,
            {params: {
                'polystr': searchstr,
                  } 
                }
            
            )
        dispatch({
            type: FETCH_DDMASTER_SUCCESS,
            payload: res.data
        })
    }
    catch(error){
        dispatch({
            type: FETCH_DDMASTER_FAILURE,
            payload: console.log(error)
        })
    }
}